import { render, staticRenderFns } from "./OptionIcon.vue?vue&type=template&id=d79b6f7a&scoped=true&"
import script from "./OptionIcon.vue?vue&type=script&lang=js&"
export * from "./OptionIcon.vue?vue&type=script&lang=js&"
import style0 from "./OptionIcon.vue?vue&type=style&index=0&id=d79b6f7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79b6f7a",
  null
  
)

export default component.exports